import React from 'react';
import { connect } from 'react-redux';

import SelectionList from './SelectionList'


const UserList = (props) => {
    
    // sort user by name asc
    props.list.sort(function(a, b) {
        if(a.name < b.name) { return -1; }
        if(a.name > b.name) { return 1; }
        return 0;
    });
    
    return <SelectionList {...props} />
};

const mapStateToProps = (state, ownProps) => {
    return {
        list: state.user.users
    }
} 

export default connect(mapStateToProps)(UserList);
